import ApiClient from "../apiClient";
import type { DayPlan } from "../../types/day-plan";

interface MultiWeekParams {
  from?: string;
  to?: string;
  weeks?: number;
}

export class DayPlanService {
  constructor(private client: ApiClient) {}

  async getToday(): Promise<DayPlan | null> {
    const json = await this.client.get<{ plan: DayPlan | null }>(
      "/api/day-plan/today",
    );
    return json.plan ?? null;
  }

  async listMultiWeek(params: MultiWeekParams = {}): Promise<DayPlan[]> {
    const query = new URLSearchParams();
    if (params.from) query.set("from", params.from);
    if (params.to) query.set("to", params.to);
    if (params.weeks) query.set("weeks", String(params.weeks));
    const suffix = query.toString() ? `?${query.toString()}` : "";
    const json = await this.client.get<{ weeks?: DayPlan[][] }>(
      `/api/day-plan/multi-week${suffix}`,
    );
    return (json.weeks ?? []).flat();
  }
}
